module.exports = __webpack_public_path__ + "static/media/facebookR.c7197cdb.png";